<template>
  <!-- -->
  <div class="form-page" :class="(showBorder? ' border': ' no-border') + (showShadow? ' shadow': ' no-shadow')">
    <div class="left">
      <el-pagination
          v-if="showPage"
          v-model:current-page="currentPage"
          v-model:page-size="currentSize"
          :page-sizes="[10, 20, 50, 100]"
          :layout="showSimple? layoutSimple: layoutDefault"
          background
          small
          :total="totalCount"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          lang="zh-cn"
          class="page-info"
      />
      <slot name="left"></slot>
    </div>
    <div><slot></slot></div>
  </div>
</template>

<script>

export default {
  emits: ["update:pageNumber", "update:pageSize", "onLoad"],
  props: {
    pageNumber: {default: 1},
    pageSize: {default: 20},
    totalCount: {default: 0},
    // 是否加载完成后自动查询数据
    defaultLoad: {default: false},
    showPage: {default: true},
    // 显示简单模式
    showSimple: {default: false},
    // 是否显示阴影和边框
    showBorder: {default: true},
    showShadow: {default: true},
  },
  watch: {
    pageNumber: {
      handler() {
        this.currentPage = this.pageNumber
      }
    },
    pageSize: {
      handler() {
        this.currentSize = this.pageSize;
      }
    }
  },
  name: "FormPage",
  components: {
  },
  data() {
    return {
      currentPage: 1,
      currentSize: 20,
      timeOut: "",
      layoutDefault: "prev, pager, next, jumper, total, sizes",
      layoutSimple: "prev, pager, next, total"
    };
  },
  created() {
    this.currentSize = this.pageSize;
    this.currentPage = this.pageNumber;
    // 自动加载数据
    if (this.defaultLoad) {
      this.$emit("update:pageNumber", this.pageNumber);
      this.$emit("update:pageSize", this.pageSize);
      this.$emit("onLoad");
    }
  },
  methods: {
    handleSizeChange(size) {
      this.$emit("update:pageSize", size);
      this.$emit("onLoad");
    },
    handleCurrentChange(page) {
      this.$emit("update:pageNumber", page);
      this.$emit("onLoad");
    }
  }
};
</script>

<style lang="scss" scoped>
.form-page{
  background: #FFF;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  .left{
    display: inline-flex;
    align-items: center;
    .page-info{
      margin-right: 10px;
    }
  }
}
.no-border.no-shadow{
  padding: 10px 0 0 0 !important;
}
</style>